'use client';

import { Vatan } from '@repo/icons';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import VatanCoinBG from '@/assets/landing-banners/vatan-coin-bg.png';
import VatanCoinMobileBG from '@/assets/landing-banners/vatan-coin-mobile-bg.jpg';
import { useTenant } from '@/providers/TenantProvider';

const CoinSection = () => {
  const t = useTranslations('landing.landing-banners');

  const {
    tenantConfig: { settings },
  } = useTenant();

  if (!settings?.enableVatanCoinPromotion) {
    return null;
  }

  return (
    <div className="w-full space-y-4">
      <label className="vt-siderbar-item-primary-text hidden items-center gap-x-2 sm:flex">
        <Vatan
          className="h-4 w-4"
          fill="#EFEFEF"
        />
        <h2 className="font-black vt-font-highlight-font-family vt-text-size-medium vt-headings-text sm:vt-text-size-big">
          {t('vatan-coin-heading')}
        </h2>
      </label>
      <div className="relative w-full">
        <a
          href="https://vatan.vatan.game/"
          target="_blank"
          title="Vatan Coin Whitepaper"
        >
          <Image
            src={VatanCoinMobileBG}
            alt="Vatan Coin"
            className="block h-auto w-full rounded sm:hidden"
            unoptimized
          />
          <Image
            src={VatanCoinBG}
            alt="Vatan Coin"
            className="hidden h-auto w-full rounded sm:block"
            unoptimized
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};

export default CoinSection;
